import React from "react";
import "./styles.scss";

const Index = ({ data, onClick }) => {
  let inputElement = null;

  inputElement = (
    <>
      <div className="page-navigation-wrapper">
        <span onClick={onClick}>{data.main}</span>
        {" > "}
        {data?.page}
      </div>
    </>
  );

  return (
    <>
      <>{inputElement}</>
    </>
  );
};

export default Index;
